import { Link } from 'react-router-dom';
import {
  SITE_NAME,
  SITE_TAGLINE,
  SITE_DESCRIPTION,
  SOCIAL_LINKS,
  CONTACT_EMAIL,
} from '../../constants/site';
import { ALL_CATEGORIES } from '../../constants/blogCategories';
import { toSlug } from '../../utils/slug';

function Footer() {
  const socials = SOCIAL_LINKS.filter((s) => s.href);

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-about">
          <Link to="/" className="brand">
            <span className="brand-mark" aria-hidden="true">
              {SITE_NAME.charAt(0)}
            </span>
            <span className="brand-name">{SITE_NAME}</span>
          </Link>
          <p className="footer-tagline">{SITE_TAGLINE}</p>
          <p className="footer-desc">{SITE_DESCRIPTION}</p>
          {socials.length > 0 && (
            <ul className="footer-social">
              {socials.map((s) => (
                <li key={s.label}>
                  <a href={s.href} rel="noopener noreferrer me" target="_blank">
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>

        <nav aria-labelledby="footer-categories">
          <h2 className="footer-heading" id="footer-categories">
            Categories
          </h2>
          <ul className="footer-list">
            {ALL_CATEGORIES.map((c) => (
              <li key={c}>
                <Link to={`/category/${toSlug(c)}`}>{c}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-labelledby="footer-site">
          <h2 className="footer-heading" id="footer-site">
            Site
          </h2>
          <ul className="footer-list">
            <li>
              <Link to="/blogs">All Articles</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms of Service</Link>
            </li>
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`}>Contact</a>
            </li>
          </ul>
        </nav>
      </div>

      <div className="container footer-bottom">
        <span>
          © {new Date().getFullYear()} {SITE_NAME}. All rights reserved.
        </span>
        <a href="/sitemap.xml">Sitemap</a>
      </div>
    </footer>
  );
}

export default Footer;
